import { Card, CardBody, CardHeader } from '../ui/Card.jsx';
import HeadingOne from '../ui/HeadingOne.jsx';
import Button from '../ui/Button.jsx';

const MessageBoss = ({ heading_img, heading, subheading, text, button, fn }) => {
  
  return (
    <div className="component-email">
      <div className="row">
        <HeadingOne className="w-8/12" image={heading_img} heading={heading} />
      </div>
      <div className="row justify-center">
        <div className="col xl:w-10/12">
          <Card>
            <CardHeader
              heading={subheading}
        
            />
            <CardBody>
              <div className="row items-center justify-center">
                <div className="col text-xl">
                  <div dangerouslySetInnerHTML={{ __html: text }}></div>
                </div>
                <div className="col text-xl">
                  {button && (
                    <div className="flex justify-end">
                      <Button {...button} onClick={() => fn.handleAction(button.action)} />
                    </div>
                  )}
                </div>
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default MessageBoss;
